import Confirmation from "./Confirmation";
import ESignatureTab from "./ESignature";

const SignatureSelection = ({
  esignatureIsSelected,
  agreeToSubmitToBrs,
  setAgreeToSubmitToBrs,
  handleBackBtn,
  goToNextStep,
}) => {
  return (
    <Confirmation
      agreeToSubmitToBrs={agreeToSubmitToBrs}
      setAgreeToSubmitToBrs={setAgreeToSubmitToBrs}
      goToNextStep={goToNextStep}
    />
  );
};

export default SignatureSelection;
